if (!window.customElements.get('show-more-list')) {
  window.customElements.define(
    'show-more-list',
    class ShowMoreList extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.getAttribute('section-id');
        this.itemsTarget = this.querySelector('[data-show-more-items]');
        this.loading = false;
        this._onClick = this._onClick.bind(this);
        this.addEventListener('click', this._onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
      }

      async _onClick(event) {
        const trigger = event.target.closest('[data-show-more-next], [data-show-more-previous]');
        if (!trigger || this.loading) return;

        event.preventDefault();
        const direction = trigger.hasAttribute('data-show-more-next') ? 'next' : 'previous';

        this.loading = true;
        trigger.setAttribute('aria-busy', 'true');

        try {
          const url = new URL(trigger.href);
          url.searchParams.set('section_id', this.sectionId);

          const response = await fetch(url);
          if (!response.ok) throw new Error('Failed to load');

          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incomingList = doc.querySelector('[data-show-more-items]');
          if (!incomingList) throw new Error('Missing items');

          const incoming = Array.from(incomingList.children).map((node) => document.importNode(node, true));

          if (direction === 'next') {
            this.itemsTarget.append(...incoming);
          } else {
            const anchor = this.itemsTarget.firstElementChild;
            const before = anchor.getBoundingClientRect().top;
            this.itemsTarget.prepend(...incoming);
            window.scrollBy(0, anchor.getBoundingClientRect().top - before);
          }

          const controlClass = direction === 'next' ? '.show-more--next' : '.show-more--previous';
          const currentControl = this.querySelector(controlClass);
          const fetchedControl = doc.querySelector(controlClass);

          if (currentControl) {
            if (fetchedControl) {
              currentControl.replaceWith(document.importNode(fetchedControl, true));
            } else {
              currentControl.remove();
            }
          }

          const historyUrl = new URL(trigger.href);
          historyUrl.searchParams.delete('section_id');
          history.replaceState({}, '', historyUrl.toString());
        } catch (error) {
          window.location.assign(trigger.href);
        } finally {
          trigger.removeAttribute('aria-busy');
          this.loading = false;
        }
      }
    },
  );
}
